export default __webpack_public_path__ + "static/media/home.6cc2c28f.svg";